<template>
  <div class="flex">
    <svg-icon type="mdi" :path="path"></svg-icon>
  </div>
</template>

<script>
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiArrowTopRight } from "@mdi/js"

export default {
  name: "ArrowTopRightIcon",
  components: {
    SvgIcon
  },
  data() {
    return {
      path: mdiArrowTopRight,
    }
  }
}
</script>
